<template>
<li>
    <div class="tree-node-div" @mouseover="changeHover(index)" @mouseout="currentHover=-1" :class="[currentHover==index?'tr-hover':'',$store.state.clickItem==model||$store.state.syncClickItem==model&&transferAimFlag?'tr-click':'tr-0d0s7',$store.state.arr.includes(model)||$store.state.syncArr.includes(model)?'tr-click':'tr-0d0s9']" @click="chooseItem(model)">
        <span @click.stop="toggle(index,model)" class="tr-height tr-tree-span">
            <i class="icon-util  pull-triangle-position" v-if="testShow(model)" :class="[model.open?'down-triangle':'pull-triangle']"></i>
            <i class="icon-util  pull-triangle-position" style="width:20Px;height:20Px;" v-if="!testShow(model)"></i>
        </span>
        <div class="tr-tree-span">
            <div class="icon-util folder-position" style="top: 11px;" :class="$store.state.arr.includes(model)?'check-small':'nocheck-small'"></div>
            <i v-loading='loading' class="folder-position " :class="[model.appName?returnName(model.appName):'small-file',model.dir?'folder-small':'',!model.dir&&!model.appName?matchfileType(model.name)+'-small':'']"></i>
            <span  ref="treeItemName" :title="model.name" class="tr-tree-name-span" @dblclick.stop="toggle(index,model)">{{model.name}}</span>
            <div class="tree-innerclass" ref="editTreeName" :class="isflage?'tree-innerclass':'tree-innerclass-not'">
                <input :class="isflage?'tree-name-edit':'tree-name-not'" v-model="inputValue" @click.stop="" @focus="isflage=true" @blur.stop="submitFolder(model)" />
                <span class="tree-input-icon">
                    <i class="icon-util name-sure" @click.stop='submitFolder(model)'></i>
                    <i class="icon-util name-cancel " @mousedown.stop='cancelNewFolder(model)'></i>
                </span>
            </div>
        </div>
        <i v-show="(treeShow&&model.driveType!='googlePhotos')||(treeShow&&(model.driveType=='googlePhotos'&&model.id == '/albums'))" @click.stop="addNewFolder(index,model)" class="icon-util add-folder-positon" :class="[currentHover==index?'add-folder':'']"></i>
    </div>
    <ul v-show="model.open">
        <tree-menu :key="index" v-for="(item,index) in model.children" :treeShow="treeShow" :model="item" :index=index :transferAimFlag='transferAimFlag'></tree-menu>
    </ul>
</li>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import '@/assets/css/tree.css';
import commonstate from '@/js/constant.js';
export default {
    name: 'treeMenu',
    props: ['model', 'index', 'treeShow', 'transferAimFlag'],
    data: function () {
        return {
            open: false,
            hasChild: true,
            currentHover: -1,
            activeClass: '',
            inputValue: null,
            isflage: true, //用于控制是否聚焦
            treeIndex: 0,
            loading: false,
            reName: null,
            syncFlag: false
        }
    },
    methods: {
        returnName(appName){
         let result;
         if(appName!='ownCloud'){
             result='icon '+appName+'-small';
         }else{
             result='icon '+appName+'-small-box';
         }
         return result;
        },
        testShow(model) {
            let flag;
            if (!model.open) {
                flag = true;
            } else {
                if (model.children && !model.children.length) {
                    flag = false;
                } else {
                    flag = true;
                }
            }
            return flag;
        },
        toggle: function (index, model, callback) {
            if (model.id) {
                let that = this;
                let modelItem = Object.assign({}, model);
                delete modelItem.children;
                this.hasChild = this.model.children;
                let transferFromOpen = this.$store.state.transferFromOpen;
                if (this.hasChild) {
                    if (!model.open) {
                        model.children = commonUtils.packageDataChildren(model.children);
                    }
                    if (!model.open) {
                        model.open = true;
                    } else {
                        if (this.hasChild.length) {
                            model.open = false;
                        }
                    }
                    that.loading = false;
                    this.$forceUpdate();
                } else {
                    let driveId;
                    let fileId;
                    let type;
                    that.loading = true;
                    if (model.appName) {
                        driveId = model.id;
                        fileId = model.rootId;
                        this.$store.commit('setTreeDriveId', driveId);
                    } else {
                        driveId = model.driveId;
                        fileId = model.id;
                    }
                    type = model.driveType;
                    let listData = {
                        ud: JSON.parse(localStorage.getItem("user")).id,
                        dd: driveId,
                        id: fileId
                    }
                    that.Utils.doFilesRequest("list", listData).then(res => {
                        that.loading = false;
                        if (res.status == 200) {
                            if (model && !model.children) {
                                model.newParam = 'children';
                                model.children = commonUtils.packageData(commonUtils.sortArr(res.items, true, 0), driveId, fileId,
                                    transferFromOpen, type);
                                let arr1 = new Array;
                                arr1 = model.children;
                                $.each(arr1, function (i, item1) {
                                    item1.newParam = 'pnode';
                                    item1.pnode = modelItem;
                                });
                            } else if (model.children) {
                                model.children = commonUtils.packageData(commonUtils.sortArr(res.items, true, 0), driveId, fileId,
                                    transferFromOpen, type);
                                let arr2 = new Array;
                                arr2 = model.children;
                                $.each(arr2, function (j, item2) {
                                    item2.newParam = 'pnode';
                                    item2.pnode = modelItem;
                                });
                            }
                            this.toggle(index, model, function (message) {});
                            if (callback != undefined) {
                                callback(res);
                            }
                        } else {
                            this.$toast({
                                text: this.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "add-item-sub-account"
                            });
                        }
                    });
                }
            }
        },
        changeHover(index) {
            this.currentHover = index;
        },
        chooseItem(model) {
            let that = this;
            let continueFlag;
            //判断是否存在不支持的目标目录
            if (this.transferAimFlag == true || this.transferAimFlag == 'CopyTo' || this.transferAimFlag == 'syncAim' ||
                this.transferAimFlag == 'remoteTask'|| this.transferAimFlag == 'addSubItem') {
                if (this.transferAimFlag == 'CopyTo' && this.$store.state.exploerselectedArr.length > 0) {
                    if (this.$store.state.exploerselectedArr[0].pid == model.id && model.driveId == this.$store.state.exploerselectedArr[0].driveId) {
                        this.cloudExploerWarn();
                        continueFlag = false;
                        return false;
                    }
                    $.each(this.$store.state.exploerselectedArr, function (i, sourceItem) {
                        if (model.id == sourceItem.id && model.driveId == sourceItem.driveId) {
                            that.cloudExploerWarn();
                            continueFlag = false;
                            return false;
                        }
                        if (model.pnode) {
                            let flag = commonUtils.checkNode(model.pnode, sourceItem);
                            if (flag) {
                                that.cloudExploerWarn();
                                continueFlag = false;
                                return false;
                            }
                        }
                    });
                }
                if (model.driveType == 'googlePhotos') {
                    if (model.id == '/sharing' || commonstate.googlePhotos.includes(model.rootId)) {
                        this.notTransferingWarn();
                    } else if (model.id == '/albums') {
                        this.selectItem(model);
                        this.notMediaFilesWarn();
                    } else if (model.id == '/photos') {
                        if (this.transferAimFlag == true || this.transferAimFlag == 'remoteTask') {
                            let that = this;
                            let leftSource = this.$parent.$parent.$parent.mulitDrives;
                            let leftArr = [];
                            $.each(leftSource, function (index, leftItem) {
                                leftArr.push(leftItem.dir);
                            });
                            if (leftArr.length && leftArr[0] == false && commonUtils.isAllEqual(leftArr)) {
                                this.selectItem(model);
                            } else {
                                this.notStoreDirectoriesWarn();
                            }
                        }
                        if (this.transferAimFlag == 'CopyTo' || this.transferAimFlag == 'remoteTask' || this.transferAimFlag ==
                            'syncAim'|| this.transferAimFlag == 'addSubItem') {
                            this.selectItem(model);
                            this.onlyStoreImagesWarn();
                        }
                    } else {
                        this.onlyAlbumWarn();
                    }
                } else if (model.driveType == 'gSuite' && model.rootId == '/') {
                    this.notTransferingWarn();
                } else if (model.driveType == 'sugarSync' && model.name != 'Web Archive' && model.name != 'Magic Briefcase' &&
                    model.name != 'Mobile Photos' && !this.testPnodeName(model)) {
                    this.sugarSyncWarn();
                } else if (model.driveType == 'flickr' && model.rootId == '/') {
                    this.flickWarn();
                } else if (model.driveType == 'baiDu' && model.id != '/apps/lin1118') {
                    this.baiDuWarn();
                } else if (model.driveType == 'dropbox4Business' && (model.rootId == '/' || model.id == 'Members')) {
                    this.dropBoxbusinessWarn();
                } else if (continueFlag != false) {
                    this.selectItem(model);
                }
            } else {
                this.selectItem(model);
            }
        },
        testPnodeName(model) {
            let nameArr = ['Web Archive', 'Magic Briefcase', 'Mobile Photos'];
            if (model.pnode) {
                if (nameArr.includes(model.pnode.name)) {
                    this.syncFlag = true;
                }
                this.testPnodeName(model.pnode);
            }
            return this.syncFlag;
        },
        selectItem(model) {
            if (this.transferAimFlag != 'syncAim') {
                let that = this;
                if (this.$store.state.multiSelect) {
                    this.$store.commit('setClickItem', -1);
                    if (this.$store.state.arr.includes(model)) {
                        this.$store.state.arr = this.$store.state.arr.filter(
                            function (ele) {
                                return ele != model;
                            });
                    } else {
                        this.$store.commit('setArr', model);
                    }
                } else {
                    that.$store.state.arr = [];
                    that.$store.commit('setClickItem', model);
                    that.$store.commit('setArr', model);
                }
            } else {
                if (this.$store.state.syncMultiSelect) {
                    this.$store.commit('setSyncClickItem', -1);
                    if (this.$store.state.syncArr.includes(model)) {
                        this.$store.state.syncArr = this.$store.state.syncArr.filter(
                            function (ele) {
                                return ele != model;
                            });
                    } else {
                        this.$store.commit('setSyncArr', model);
                    }
                } else {
                    this.$store.state.syncArr = [];
                    this.$store.commit('setSyncClickItem', model);
                    this.$store.commit('setSyncArr', model);
                }

            }
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        addNewFolder(index, model) {
            let that = this;
            that.isflage = true;
            this.hasChild = model.children && model.children.length;
            if (this.hasChild || this.hasChild == 0) {
                model.open = true;
                if (!model.children) {
                    model.children = new Array;
                }
                let JsonList = that.judgeRepeatFolderName(model);
                $.each(model.children, function (i, item) {
                    JsonList.push(item);
                });
                model.children = JsonList;
                that.$forceUpdate();
                that.$nextTick(function () {
                    that.editInputStyle("inline-block", "none", model);
                })
            } else {
                that.toggle(index, model, function (message) {
                    if (message.status == 200) {
                        let JsonList = that.judgeRepeatFolderName(model);
                        $.each(model.children, function (i, item) {
                            JsonList.push(item);
                        });
                        model.children = JsonList;
                        that.$forceUpdate();
                        that.$nextTick(function () {
                            that.editInputStyle("inline-block", "none", model);
                        })

                    }
                });
            }
        },
        editInputStyle(inputDomStye, divDomStyle, model) {
            let inputDom = this.$children[0].$refs.editTreeName;
            let divDom = this.$children[0].$refs.treeItemName;
            this.$children[0].inputValue = model.children[0].name;
            inputDom.style.display = inputDomStye;
            divDom.style.display = divDomStyle;
            this.$nextTick(function () {
                inputDom.children[0].select();
            });
        },
        editDivStyle(inputDomStye, divDomStyle) {
            let inputDom = this.$refs.editTreeName;
            let divDom = this.$refs.treeItemName;
            inputDom.style.display = inputDomStye;
            divDom.style.display = divDomStyle;
        },
        cancelNewFolder(model) {
            let that = this;
            this.isflage = false;
            let children = model.pnode.children;
            children.splice(0, 1);
            this.$nextTick(function () {
                this.editDivStyle("none", "inline-block");
            })
            let t = setTimeout(() => {
                that.isflage = true;
                clearTimeout(t);
            }, 2000);
        },
        submitFolder(model) {
            if (this.isflage) {
                this.isflage = false;
                let tid;
                let dd;
                let driveType;
                let pnode;
                let that = this;
                let nameArr = [];
                for (let i = 1; i < model.pnode.children.length; i++) {
                    nameArr.push(model.pnode.children[i].name);
                }
                commonUtils.includesFileName(nameArr, that.inputValue, this);
                that.inputValue = that.reName;
                if (model.pnode.rootId) {
                    tid = model.pnode.rootId;
                    dd = model.pnode.id;
                } else {
                    tid = model.pnode.id;
                    dd = model.pnode.driveId;
                }
                driveType = model.pnode.driveType;
                pnode = model.pnode;
                let mkdirData = {
                    tid: tid,
                    ud: JSON.parse(localStorage.getItem("user")).id,
                    dd: dd,
                    n: that.inputValue
                }
                if (that.inputValue) {
                    model.name = that.inputValue;
                }
                this.Utils.doFilesRequest("mkdir", mkdirData).then(res => {
                    if (res.status == 200) {
                        var data = JSON.parse(JSON.stringify(res.item));
                        model.name = data.name;
                        model.dir = data.dir;
                        model.id = data.id;
                        model.modifiedTime = data.modifiedTime;
                        model.driveId = dd;
                        model.pid = tid;
                        model.driveType = driveType;
                        model.pnode = pnode;
                        let key = tid + dd;
                        let tableData = that.$store.state.cacheTableDatas[key];
                        if (tableData) {
                            tableData.tableData.push(model);
                            that.$store.commit("setCacheTableDatas", {
                                id: key,
                                tableData: tableData.tableData
                            });
                        }
                        let JsonList = [];
                        JsonList.push(model);
                        model.pnode.children.splice(0, 1);
                        $.each(model.pnode.children, function (i, item) {
                            JsonList.push(item);
                            if (i == model.pnode.children.length - 1) {
                                model.pnode.children = JsonList;
                                let t = setTimeout(function () {
                                    that.editDivStyle("none", "inline-block");
                                    clearTimeout(t);
                                    that.isflage = true;
                                }, 2000);
                                return false;
                            }
                        });
                        if (!model.pnode.children.length) {
                            model.pnode.children = JsonList;
                            let t = setTimeout(function () {
                                that.editDivStyle("none", "inline-block");
                                clearTimeout(t);
                                that.isflage = true;
                            }, 2000);
                        }
                    } else {
                        model.pnode.children.splice(0, 1);
                        that.selectItem(model);
                        that.editDivStyle("none", "inline-block");
                        that.$forceUpdate();
                        that.$toast({
                            text: that.$t('language.exception.createFolderFail'),
                            type: 'fail',
                            idValue: 'add-item-sub-account',
                        });
                    }
                });
            }
        },
        judgeRepeatFolderName(model) {
            let childrens = model.children;
            let JsonList = [];
            var name = "New Folder";
            var j = 0;
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].name == name) {
                    j = j + 1;
                    name = "New Folder(" + j + ")";
                    i = -1;
                    continue;
                }
            }
            let newItem = {
                name: name,
                dir: true
            };
            newItem.pnode = model;
            JsonList.push(newItem);
            return JsonList;
        },
        notTransferingWarn() {
            this.$toast({
                text: this.$t('language.exception.notTransferring'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        notMediaFilesWarn() {
            this.$toast({
                text: this.$t('language.exception.notMediaFiles'),
                type: 'notice',
                idValue: 'add-item-sub-account',
                learnMoreShow: false
            });
        },
        notStoreDirectoriesWarn() {
            this.$toast({
                text: this.$t('language.exception.notStoreDirectories'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        onlyStoreImagesWarn() {
            this.$toast({
                text: this.$t('language.exception.onlyStoreImages'),
                type: 'notice',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        sugarSyncWarn() {
            this.$toast({
                text: this.$t('language.exception.sugarSyncWarn'),
                type: 'fail',
                idValue: "add-item-sub-account",
                learnMoreShow: true
            });
        },
        flickWarn() {
            this.$toast({
                text: this.$t('language.exception.flickWarn'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        baiDuWarn() {
            this.$toast({
                text: this.$t('language.exception.baiDuWarn'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        dropBoxbusinessWarn() {
            this.$toast({
                text: this.$t('language.exception.dropBoxbusinessWarn'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        onlyAlbumWarn() {
            this.$toast({
                text: this.$t('language.exception.onlyAlbum'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        cloudExploerWarn() {
            this.$toast({
                text: this.$t('language.common.selectOther'),
                type: 'fail',
                idValue: 'add-item-sub-account',
                learnMoreShow: true
            });
        },
        getIdValue() {
            let idValue;
            if (this.transferAimFlag == 'CopyTo') {
                idValue = 'CopyTo';
            } else if (this.transferAimFlag == 'syncAim') {
                idValue = 'transferAim'
            } else {
                idValue = 'pleaseSelect'
            }
            return idValue;
        }

    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 40) {
                return value.slice(0, 40) + '...';
            }
            return value;
        }
    }
}
</script>

<style>
#pleaseSelect ul,
#sourceSelect ul,
#transferAim ul {
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 15px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

#pleaseSelect li,
#sourceSelect li,
#transferAim li {
    list-style: none;
    min-width: 460px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
}

#pleaseSelect .tree-node-div,
#sourceSelect .tree-node-div,
#transferAim .tree-node-div {
    word-break: keep-all;
    white-space: nowrap;
    min-width: 460px;
    /*no*/
    height: 40px;
    /*no*/
    overflow: hidden;
}

.tree-innerclass {
    width: 180px;
    /*no*/
    height: 35px;
    /*no*/
    float: left;
    display: none;
}

.tree-innerclass-not {
    width: 180px;
    /*no*/
    height: 35px;
    /*no*/
    float: left;
    display: none;
    pointer-events: none;
}

.tree-name-edit {
    background: #fff !important;
    margin-top: 7px;
    /*no*/
    height: 25px;
    /*no*/
    width: 180px;
    /*no*/
    float: left;
    font-size: 14px;
    /*no*/
    padding: 0px 45px 0px 5px;
    /*no*/
    float: left;
    border: 1px solid #4181ff !important;
    /*no*/
    box-sizing: border-box;
}

.tree-name-not,
.tree-name-not:hover {
    background: #fff !important;
    margin-top: 7px;
    /*no*/
    height: 25px;
    /*no*/
    width: 180px;
    /*no*/
    float: left;
    font-size: 14px;
    /*no*/
    padding: 0px 45px 0px 5px;
    /*no*/
    float: left;
    border: 1px solid #cdcdcd !important;
    /*no*/
    box-sizing: border-box;
    position: relative;
    pointer-events: none;

}

.tree-input-icon {
    width: 40px;
    /*no*/
    height: 25px;
    /*no*/
    position: relative;
    left: -47px;
    /*no*/
    top: 7px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/trees/sub_account_tree.vue